(function () {
  'use strict';

  var LINE_PRICE_SELECTOR = '[data-hulkapps-line-price]';
  var FINAL_PRICE_SELECTOR = '[data-item-final-price-display]';
  var QUANTITY_SELECTOR = '[data-cart-quantity]';
  var CART_ITEM_SELECTOR = '[data-item-row], [data-hulkapps-lineitem], .cart-item';

  function parseMoneyToCents(value) {
    var cleaned = String(value || '')
      .replace(/[^\d.,-]/g, '')
      .trim();

    if (!cleaned) return NaN;

    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    var normalized;

    if (lastComma > lastDot) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = cleaned.replace(/,/g, '');
    }

    var amount = parseFloat(normalized);
    if (isNaN(amount)) return NaN;

    return Math.round(amount * 100);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format || Shopify.money_format);
    }

    return (cents / 100).toFixed(2);
  }

  function getCartItem(element) {
    return element.closest(CART_ITEM_SELECTOR);
  }

  function getQuantity(cartItem) {
    if (!cartItem) return NaN;

    var quantityInput = cartItem.querySelector(QUANTITY_SELECTOR);
    if (!quantityInput) return NaN;

    return parseInt(quantityInput.value, 10);
  }

  function updateFinalPriceDisplays(cartItem, formattedPrice) {
    if (!cartItem) return;

    cartItem.querySelectorAll(FINAL_PRICE_SELECTOR).forEach(function (displayEl) {
      // Side cart markup can put both attributes on the same node; leave those alone.
      if (displayEl.hasAttribute('data-hulkapps-line-price')) return;
      displayEl.textContent = formattedPrice;
    });
  }

  function updateFromLinePrice(linePriceEl) {
    var cartItem = getCartItem(linePriceEl);
    var quantity = getQuantity(cartItem);

    if (!quantity || quantity < 1) return;

    var lineCents = parseMoneyToCents(linePriceEl.textContent);
    if (isNaN(lineCents)) return;

    var unitCents = Math.round(lineCents / quantity);
    updateFinalPriceDisplays(cartItem, formatMoney(unitCents));
  }

  function updateAllLinePrices() {
    document.querySelectorAll(LINE_PRICE_SELECTOR).forEach(updateFromLinePrice);
  }

  function observeLinePriceUpdates() {
    var cartRoot =
      document.querySelector('cart-items') ||
      document.querySelector('[data-cart]') ||
      document.querySelector('.cart-list') ||
      document.body;

    if (!cartRoot || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        if (mutation.type === 'characterData') {
          return !!mutation.target.parentElement &&
            !!mutation.target.parentElement.closest(LINE_PRICE_SELECTOR);
        }

        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          var target = mutation.target;
          return (
            (target.nodeType === 1 &&
              (target.matches(LINE_PRICE_SELECTOR) ||
                target.querySelector(LINE_PRICE_SELECTOR))) ||
            (target.parentElement && target.parentElement.closest(LINE_PRICE_SELECTOR))
          );
        }

        return false;
      });

      if (shouldUpdate) updateAllLinePrices();
    });

    observer.observe(cartRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    updateAllLinePrices();
    observeLinePriceUpdates();

    [300, 1000, 2500].forEach(function (delay) {
      window.setTimeout(updateAllLinePrices, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
